module.exports = __webpack_public_path__ + "img/rate.bf181dfe.png";